import { useState } from 'react';

import { Box, Flex, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Song } from '~/@types/tsl-types';
import MusicIcon from '~/assets/icons/music.svg?react';
import { useSongsFoundSelector } from '~/store/slices/search-hook';

type Props = {
  songs?: Song[];
  minSongs?: number;
};

function Titles({ songs, minSongs = 6 }: Props) {
  const { t } = useTranslation('common');

  const songsFound = useSongsFoundSelector();
  const [maxDisplay, setMaxDisplay] = useState(minSongs);

  return (
    <Stack minW='100%'>
      <Flex direction='row' justifyContent='space-between' minW='100%' mb={3}>
        <Text fontSize='18px' fontWeight='600'>
          Title(s)
        </Text>
        {maxDisplay === Infinity ? (
          <Text
            fontSize='13px'
            textDecoration='underline'
            cursor='pointer'
            onClick={() => setMaxDisplay(minSongs)}
          >
            {t('actions.seeLess')}
          </Text>
        ) : (
          <Text
            fontSize='13px'
            textDecoration='underline'
            cursor='pointer'
            onClick={() => setMaxDisplay(Infinity)}
          >
            {t('actions.allTitles')}
          </Text>
        )}
      </Flex>

      <SimpleGrid columns={2} spacing={5}>
        {(songs ?? songsFound).slice(0, maxDisplay).map((song, index) => (
          <Flex key={index} direction='row' alignItems='center'>
            <Box mx={3}>
              <MusicIcon />
            </Box>

            <Stack spacing={0} w='300px' overflow='hidden'>
              <Text
                fontSize='16px'
                fontWeight='600'
                overflow='hidden'
                whiteSpace='nowrap'
                textOverflow='ellipsis'
              >
                {song.title}
              </Text>
              <Text
                fontSize='14px'
                fontWeight='200'
                overflow='hidden'
                whiteSpace='nowrap'
                textOverflow='ellipsis'
              >
                {song.artist.name}
              </Text>
            </Stack>
          </Flex>
        ))}
      </SimpleGrid>
    </Stack>
  );
}

export default Titles;
